import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import './DoNotSell.scss'

export default function DoNotSell() {
    const [submitted, setSubmitted] = useState(false)
    const [email, setEmail] = useState("")

    function handleSubmit(e) {
        e.preventDefault()
        if (!email) return
        // TODO: hook into your privacy request backend / email automation
        setSubmitted(true)
    }

    return (
        <div className="DoNotSell">
            <Helmet>
                <title>Do Not Sell or Share My Personal Information | HandyBy</title>
                <meta name="description" content="Submit a request to opt out of the sale or sharing of your personal information under California, Colorado, Virginia, and Connecticut privacy laws (CCPA/CPRA, CPA, VCDPA, CTDPA)." />
                <link rel="canonical" href="https://www.handyby.com/do-not-sell" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className="DoNotSellInner">
                <h1>Do Not Sell or Share My Personal Information</h1>

                <p>
                    Under the California Consumer Privacy Act (as amended by the CPRA), the Colorado Privacy Act,
                    the Virginia Consumer Data Protection Act, the Connecticut Data Privacy Act, and similar laws,
                    you have the right to opt out of the “sale” or “sharing” of your personal information, including
                    the use of your information for cross-context behavioral advertising (such as advertising cookies
                    and tracking pixels).
                </p>

                <h2>What HandyBy does with your data</h2>
                <p>
                    HandyBy connects you with verified local home service professionals. To do that, we collect
                    information you submit (name, contact, ZIP, project details) and pass it to the matched pro.
                    We also use third-party advertising and analytics technologies (Google Ads, Microsoft Ads,
                    OpenAI Ads, Google Analytics, CallRail) that may constitute “sharing” under these laws.
                </p>

                <h2>Submit a do-not-sell / do-not-share request</h2>
                <p>
                    Fill out the form below and we’ll process your request within 15 business days as required by
                    law. We’ll confirm receipt by email and, on completion, opt your browser out of advertising
                    sharing where technically feasible. You can also opt out at the browser level using a Global
                    Privacy Control (GPC) signal — we honor GPC automatically.
                </p>

                {!submitted ? (
                    <form className="DoNotSellForm" onSubmit={handleSubmit}>
                        <label>
                            Email address
                            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
                        </label>
                        <button type="submit">Submit request</button>
                    </form>
                ) : (
                    <div className="DoNotSellSuccess">
                        <h3>Request received</h3>
                        <p>We’ll email a confirmation to <strong>{email}</strong> shortly. If you don’t see it, check spam or contact us at <a href="mailto:privacy@handyby.com">privacy@handyby.com</a>.</p>
                    </div>
                )}

                <h2>Other ways to contact us</h2>
                <ul>
                    <li><strong>Email:</strong> <a href="mailto:privacy@handyby.com">privacy@handyby.com</a></li>
                    <li><strong>Mailing address:</strong> available on request</li>
                </ul>

                <h2>Related policies</h2>
                <ul>
                    <li><a href="/privacy-policy">Full Privacy Policy</a></li>
                    <li><a href="/terms-of-use">Terms of Use</a></li>
                </ul>
            </div>
        </div>
    )
}
